export default "__VITE_ASSET__COrK2c87__"